import { ShieldCheck } from "lucide-react";
import Reveal, { Eyebrow } from "./Reveal";

export default function Guarantee() {
  return (
    <section id="track-record" className="relative" data-testid="track-record-section">
      <div className="bg-abyss py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal>
            <Eyebrow>Proven track record</Eyebrow>
            <div className="mt-6 flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
              <h2 className="max-w-3xl font-display text-2xl font-bold tracking-tight text-sand sm:text-3xl lg:text-5xl" data-testid="track-record-heading">
                In every category, we are the best —{" "}
                <span className="text-outline">and the record proves it.</span>
              </h2>
              <p className="max-w-md text-base text-mist">
                Every engagement ends the same way: an approved plan, an accepted correction, and a
                facility back in good standing. That is not a promise — it is our history.
              </p>
            </div>
          </Reveal>
        </div>
      </div>

      <div id="guarantee" className="bg-ochre py-20 lg:py-28" data-testid="guarantee-banner">
        <div className="mx-auto flex max-w-7xl flex-col items-start gap-10 px-6 lg:flex-row lg:items-center lg:px-10">
          <Reveal className="shrink-0">
            <div className="flex h-24 w-24 items-center justify-center rounded-3xl bg-basalt text-ochre lg:h-32 lg:w-32">
              <ShieldCheck size={56} strokeWidth={1.5} />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-basalt/70">
              The Hale Pono Guarantee
            </span>
            <h3 className="mt-3 font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-basalt sm:text-4xl lg:text-6xl" data-testid="guarantee-heading">
              We guarantee our work — or your money back.
            </h3>
            <p className="mt-5 max-w-2xl text-base font-medium text-basalt/80 sm:text-lg">
              A 100% compliance record lets us say what no one else in this field will: if we take
              your case, we stand behind the outcome completely.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
